import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateCustomerApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateCustomer = createAsyncThunk('updateCustomer', async (payload) => {
  return await updateCustomerApi(payload);
});

const updateCustomerSlice = createSlice({
  name: 'updateCustomer', // Unique Name
  initialState,
  reducers: {
    updateCustomerReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCustomer.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateCustomer.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateCustomer.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateCustomerReset } = updateCustomerSlice.actions;

export default updateCustomerSlice.reducer;
